import * as moment from 'moment';
export class DateTimeGuru {
    static DMY_TO_DATE(date: string) {
        date.replace('/', '-');
        return moment(date, 'DD-MM-YYYY').toDate();
    }
    static YMD_TO_DATE(date: string) {
        date.replace('/', '-');
        return moment(date, 'YYYY-MM-DD').toDate();
    }
    static DMY_TO_YMD(date: string) {
        date.replace('/', '-');
        return moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
    static YMD_TO_DMY(date: string) {
        date.replace('/', '-');
        return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
    }
}




// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/datetime.guru.ts